'use es6';

import { useSelector } from 'react-redux';
import { useHideDialog } from 'reporting-action-components/dialog/ducks';
import { REPORT_TEMPLATE } from 'reporting-enablement/components/singleReportViewer/common/Usage';
import AsyncSingleReportViewerModal from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerModal';
import { trackEvent } from '../lib/usageTracker';
import { UsageTracker } from 'analytics-tools-lib/lib/trackers';
import useNormalizedReport from '../lib/useNormalizedReport';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportViewerModal = props => {
  const {
    report
  } = props;
  const onClose = useHideDialog();
  const userInfo = useSelector(state => state.auth);
  const normalizedReport = useNormalizedReport({
    report: report.delete('id')
  });
  if (!normalizedReport) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncSingleReportViewerModal, {
    onClose: onClose,
    appUsageTracker: UsageTracker,
    report: normalizedReport,
    track: trackEvent,
    description: normalizedReport.get('description'),
    use: REPORT_TEMPLATE,
    userInfo: userInfo
  });
};
export default ReportViewerModal;